import { Skeleton } from '@acctglobal/skeleton'
import React, { useEffect, useState } from 'react'

import { DesktopFirstMenu } from './components/DesktopFirstMenu/DesktopFirstMenu'
import { DesktopSecondMenu } from './components/DesktopSecondMenu/DesktopSecondMenu'
import { DesktopMenuAccordion } from './DesktopMenuAccordion/DesktopMenuAccordion'
import { useCmsLandingPageContext } from '../../../contexts/CmsLandingPage'
import { useStoreContext } from '../../../contexts/StoreContext'
import { useHasActiveCoupons } from '../../../hooks/useHasActiveCoupons'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

import './desktop-menu.scss'

const Menu = () => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null)
  const { isMobile: isMobileHook } = useWindowDimensions()
  const [menuVisible, setMenuVisible] = useState(false)
  const {
    allCategories: menuAccordionCategories,
    menuFirst,
    menuSecond,
    hasWhatsappOffers,
  } = useStoreContext()

  const { couponsLoading, hasActiveCoupons } = useHasActiveCoupons()
  const { campaignMenuSecond, loading } = useCmsLandingPageContext()

  const newMenuSecond =
    window.location.pathname.includes('campanhas') && campaignMenuSecond
      ? campaignMenuSecond
      : menuSecond

  useEffect(() => {
    setIsMobile(isMobileHook)
  }, [isMobileHook])

  if (isMobile === null || loading) {
    return (
      <div className="loading-submenu" data-testid="loading-submenu">
        <Skeleton height={52} backgroundColor="var(--color-main)" />
        <Skeleton height={42} backgroundColor="var(--color-grayScale-faded)" />
      </div>
    )
  }

  return (
    !isMobile &&
    menuAccordionCategories && (
      <>
        <div className="submenu grid-content-full">
          <div className="submenu-content">
            <DesktopMenuAccordion
              couponsLoading={couponsLoading}
              hasActiveCoupons={hasActiveCoupons}
              setMenuOpen={setMenuVisible}
              allCategories={menuAccordionCategories}
              menuOpen={menuVisible}
            />
            <DesktopFirstMenu
              menu={menuFirst}
              hasWhatsappOffers={hasWhatsappOffers}
            />
          </div>
        </div>
        <DesktopSecondMenu menu={newMenuSecond} />
      </>
    )
  )
}

export default Menu
